import React, { useEffect, useState } from "react"

// Components
import ProductBox from "./ProductBox"

/**
 * @param combined product data - shopifyData && product/apparelData for the product
 * @param type - product type
 * @param handleOpenQuickBuyModal - open popup
 * @param handleProduct - set selected product
 * @param handleShopify - set selected shopify item
 * @param imgOrientation - img style: vertical, vertical-top or ''
 * @param handleSelectedProductColor - update selected color
 * **/
const ProductBoxContainer = ({
  data,
  type,
  handleOpenQuickBuyModal,
  handleProduct,
  handleShopify,
  imgOrientation,
  handleSelectedProductColor,
  aboveTheFold,
}) => {
  // Set duplicates
  const [colorOption, setColorOption] = useState([])

  const columnClass =
    type === "merchandise" || type === "supplements" || type === "meal plan" ? "col-lg-4 col-xl-3" : "col-lg-4"

  // Set colors and shopify variant id
  useEffect(() => {
    if (!data.shopifyData.options.length) return
    // Check if the box should be duplicated
    data.shopifyData.options.forEach(option => {
      if (option.name.toLowerCase() === "color") {
        setColorOption(option.values)
      }
    })
  }, [])

  return (
    <>
      {colorOption.length ? (
        colorOption.map((color, index) => (
          <div key={`color-option-${index}`} className={`col-12 col-sm-6 ${columnClass} margin-responsive`}>
            <ProductBox
              handleOpenQuickBuyModal={handleOpenQuickBuyModal}
              handleProduct={handleProduct}
              type={type}
              shopifyProduct={data.shopifyData}
              handleShopify={handleShopify}
              product={data.productData}
              imgOrientation={imgOrientation}
              color={color}
              handleSelectedProductColor={handleSelectedProductColor}
              aboveTheFold={aboveTheFold}
            />
          </div>
        ))
      ) : (
        <div className={`col-12 col-sm-6 ${columnClass} margin-responsive`}>
          <ProductBox
            handleOpenQuickBuyModal={handleOpenQuickBuyModal}
            handleProduct={handleProduct}
            type={type}
            shopifyProduct={data.shopifyData}
            handleShopify={handleShopify}
            product={data.productData}
            imgOrientation={imgOrientation}
            aboveTheFold={aboveTheFold}
          />
        </div>
      )}
    </>
  )
}
export default ProductBoxContainer
